import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchTasks(params, config) {
  return axiosRequest('post', serviceUrls.REQUIRED_ACTIONS_GET_ACTIONS, params, config);
}

export function fetchTasksFilters() {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_GET_TASKS_FILTERS);
}

export function fetchTaskGroupIds(taskGroupId, caseId, fastFilter) {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_GET_GROUP_IDS, { taskGroupId, caseId, fastFilter });
}

export function getTaskProfileById(taskId) {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_GET_ACTIONS_PROFILE, { taskId });
}

export function fetchTableFilters() {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_GET_TABLE_FILTERS);
}

export function getGroupTaskDetails(taskId) {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_GET_GROUP_TASK_DETAILS, { taskId });
}

export function completeTasks(taskIds, menuTypeCode, caseId) {
  if (menuTypeCode === 2) {
    return axiosRequest('post', serviceUrls.REQUIRED_ACTIONS_COMPLETE_DOCUMENT_TASKS, { taskIds, menuTypeCode, caseId });
  } else {
    return axiosRequest('post', serviceUrls.REQUIRED_ACTIONS_COMPLETE_TASKS, { taskIds });
  }
}

export function saveGroupTask(request) {
  return axiosRequest('post', serviceUrls.REQUIRED_ACTIONS_SAVE_GROUP_TASK, request);
}

export function getTemplateDetails(taskId) {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_TEMPLATE_DOWNLOAD, { taskId });
}

export function downloadTemplateAPI(attachmentID, taskId) {
  return axiosRequest('get', serviceUrls.REQUIRED_ACTIONS_DOCUMENT_DOWNLOAD, { attachmentID, taskId });
}

export function saveTaskDocument(request) {
  return axiosRequest('post', serviceUrls.REQUIRED_ACTIONS_DOCUMENT_CHECKBOX, request);
}
